import React, { useState, useEffect, memo } from 'react';

const ProgressIndicator = memo(({ progress, isGenerating, currentStep }) => {
  const [estimatedTime, setEstimatedTime] = useState(null);
  const [startTime, setStartTime] = useState(null);

  useEffect(() => {
    if (isGenerating && progress > 0 && progress < 1) {
      if (!startTime) {
        setStartTime(Date.now());
      } else {
        const elapsedMs = Date.now() - startTime;
        const totalEstimatedMs = elapsedMs / progress;
        const remainingMs = totalEstimatedMs - elapsedMs;

        if (remainingMs > 0) {
          const remainingSeconds = Math.round(remainingMs / 1000);
          setEstimatedTime(remainingSeconds);
        }
      }
    } else if (!isGenerating || progress >= 1) {
      setStartTime(null);
      setEstimatedTime(null);
    }
  }, [progress, isGenerating, startTime]);

  if (!isGenerating) return null;

  return (
    <div className="progress-container">
      {currentStep && (
        <div className="progress-step">
          <span className="processing-spinner"></span>
          {currentStep}
        </div>
      )}

      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${Math.round(progress * 100)}%` }}
        />
      </div>

      <div className="progress-text">
        <div>{Math.round(progress * 100)}%</div>
        {estimatedTime !== null && (
          <div className="time-remaining">
            ~{estimatedTime > 60
              ? `${Math.floor(estimatedTime / 60)}m ${estimatedTime % 60}s`
              : `${estimatedTime}s`} remaining
          </div>
        )}
      </div>
    </div>
  );
});

ProgressIndicator.displayName = 'ProgressIndicator';

export default ProgressIndicator;
